import React from 'react';
import { useIsAdmin } from '@/utils/auth/roleChecker';
import { NotFound } from '@/pages/others/NotFound';

type AdminOnlyGuardProps = {
  children: React.ReactNode;
};

export const AdminOnlyGuard: React.FC<AdminOnlyGuardProps> = ({ children }) => {
  const isAdmin = useIsAdmin();

  if (!isAdmin) {
    return <NotFound />;
  }

  return <>{children}</>;
};
